import { FunctionComponent, memo, useContext } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { Button } from "@edgetier/components";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { useRemoveRole } from "hooks-for/permissions/use-remove-role";
import { EllipsisMenuContext, EllipsisMenuItem } from "@edgetier/client-components";
import { IProps } from "./remove-role-action.types";
import "./remove-role-action.scss";

/**
 * Remove a role. Opens a modal windw as a comfirmation message
 * @param props.actionLabel     Label used in modal header and button
 * @param props.children        Child component containing the message
 * @param props.role            Role intended to be removed
 */
const RemoveRoleAction: FunctionComponent<IProps> = ({ children, actionLabel, role }) => {
    const { lockOpen, unlock } = useContext(EllipsisMenuContext);
    const { openModal, closeModal, modalProps } = useModal({ onCloseModal: unlock });

    const { mutate: removeRoleMutate, isLoading } = useRemoveRole(role, { onSettled: closeModal });
    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>{actionLabel}</h2>
                </ModalHeader>
                <ModalContent>
                    {children}
                    <div className="role-action__remove__button">
                        <Button
                            icon={faTrash}
                            styleName="negative"
                            onClick={() => removeRoleMutate(role)}
                            isLoading={isLoading}
                        >
                            {actionLabel}
                        </Button>
                    </div>
                </ModalContent>
            </Modal>
            <EllipsisMenuItem
                closeAfterClick={false}
                icon={faTrash}
                onClick={() => {
                    lockOpen();
                    openModal();
                }}
            >
                Delete
            </EllipsisMenuItem>
        </>
    );
};

export default memo(RemoveRoleAction);
